/***************************************************
 * Created by nanyuantingfeng on 2020/4/21 16:07. *
 ***************************************************/
import { cloneDeep, get } from 'lodash'
import { related } from '../../../elements/feeDetailViewList/Related'
import { Fetch } from '@ekuaibao/fetch'

export function formatNewTemplateValue(value = {}, template = [], oldTemplate) {
  const v = cloneDeep(value)
  const fieldMap = template?.reduce((result, field) => {
    result[field.field] = field
    return result
  }, {})
  Object.keys(v).forEach(key => {
    const field = fieldMap[key]
    const type = get(field, 'dataType.type', '')

    if (field?.type === 'splitCalculation') {
      delete v[key]
    }

    if (key === 'expenseLink' || key === 'expenseLinks') {
      fnClearExpenseLink(template, v, key, oldTemplate)
    }

    // 切换模板时如果是固定值且有值，把之前的值清除了
    if (
      !!oldTemplate &&
      v[key] &&
      !field?.editable &&
      field?.defaultValue?.type === 'constant' &&
      field?.defaultValue?.value
    ) {
      v[key] = field?.defaultValue?.value?.id || field?.defaultValue?.value.ids
    }

    // TODO 天阳(bnB3nHI6Fb3qzw)的切换模板时如果是固定值且有值，把之前的值清除了,不用判断是否是可编辑的
    if (Fetch.ekbCorpId === 'bnB3nHI6Fb3qzw') {
      if (v[key] && field?.defaultValue?.type === 'constant' && field?.defaultValue?.value) {
        delete v[key]
      }
    }

    if (
      !field?.editable &&
      field?.defaultValue?.type !== 'none' &&
      field?.field !== 'invoiceForm' &&
      type !== 'text' &&
      type !== 'ref'
    ) {
      if (type === 'dateRange' && ['submit.travelPlan'].includes(field?.defaultValue?.value)) {
        return
      }
      if (type === 'date' && ['firstSubmit.date', 'submit.date'].includes(field?.defaultValue?.value)) {
        console.log('首次送审日期,数据不删除,还把数据保留', v, key)
      } else if (type === 'money' && field?.defaultValue?.type === 'sum') {
      } else {
        delete v[key]
      }
    }
  })
  const invoiceFormField = template.find(el => el.name === 'invoiceForm')
  if (invoiceFormField && !v[invoiceFormField.name]) {
    v[invoiceFormField.name] = invoiceFormField.editable
      ? { type: invoiceFormField.invoiceType?.defaultInvoiceType || 'noWrite' }
      : { type: invoiceFormField.defaultValue?.value || 'noWrite' }
  }
  if (value.alterFlag) {
    //申请单变更标识，如果有的话要保留
    v.alterFlag = value.alterFlag
  }
  return v
}

function fnClearExpenseLink(template, v, key, oldTemplate) {
  const expenseLink = template?.find(el => ['expenseLink', 'expenseLinks'].includes(el.field))
  const expenseLinkFlag = key !== get(expenseLink, 'field')
  const oldExpenseLink = oldTemplate?.components?.find(el => ['expenseLink', 'expenseLinks'].includes(el.field))
  const expenseLinksFlag = get(oldExpenseLink, 'allowMultipleRequests') !== get(expenseLink, 'allowMultipleRequests')

  if (expenseLinkFlag || (expenseLinksFlag && v[key] && v[key].length > 1)) {
    v.details?.forEach(line => {
      if (line.feeTypeForm.linkDetailEntities) {
        delete line.feeTypeForm.linkDetailEntities
      }
    })
    delete v[key]
    related.clearRelatedData()
  }
}

/**
 * @desc 切换模板对关联申请的权限控制
 * @param {*} value
 * @param {*} newT
 * @returns
 */
export const formatExpenseLinkInfo = (value, newT) => {
  const { expenseLink, expenseLinks } = value
  const newRequisitionList = (newT?.configs || []).find(it => it.ability === 'apply')?.requisitionList?.ids || []
  if (expenseLink) {
    const expenseLinkTemId = expenseLink.specificationId?.originalId
    if (checkExpenseLinksDelete(newRequisitionList, expenseLinkTemId)) {
      delete value.expenseLink
    }
  }
  if (expenseLinks) {
    const expenseLinkTemId = expenseLinks[0]?.specificationId?.originalId
    if (checkExpenseLinksDelete(newRequisitionList, expenseLinkTemId)) {
      delete value.expenseLinks
    }
  }
  return value
}

const checkExpenseLinksDelete = (newRequisitionList, expenseLinkTemId) => {
  return newRequisitionList.length && !newRequisitionList.includes(expenseLinkTemId)
}
